/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserExcludingFcmMessageIdFcmTokenWithRelations } from './userExcludingFcmMessageIdFcmTokenWithRelations';
import { JobPositionExcludingFcmMessageIdFcmTokenWithRelations } from './jobPositionExcludingFcmMessageIdFcmTokenWithRelations';
import { HumanCapitalCompanyExcludingFcmMessageIdFcmTokenWithRelations } from './humanCapitalCompanyExcludingFcmMessageIdFcmTokenWithRelations';
import { RequisitionCommentExcludingFcmMessageIdFcmTokenWithRelations } from './requisitionCommentExcludingFcmMessageIdFcmTokenWithRelations';
import { BusinessUnitExcludingFcmMessageIdFcmTokenWithRelations } from './businessUnitExcludingFcmMessageIdFcmTokenWithRelations';
import { PersonalRequisitionTypeExcludingFcmMessageIdFcmTokenWithRelations } from './personalRequisitionTypeExcludingFcmMessageIdFcmTokenWithRelations';
import { RequisitionStatusHistoryExcludingFcmMessageIdFcmTokenWithRelations } from './requisitionStatusHistoryExcludingFcmMessageIdFcmTokenWithRelations';
import { CompanyExcludingFcmMessageIdFcmTokenWithRelations } from './companyExcludingFcmMessageIdFcmTokenWithRelations';
import { RequisitionStatusExcludingFcmMessageIdFcmTokenWithRelations } from './requisitionStatusExcludingFcmMessageIdFcmTokenWithRelations';


/**
 * (tsType: Omit<PersonalRequisitionWithRelations, \'fcmMessageId\' | \'fcmToken\'>, schemaOptions: { includeRelations: true, exclude: [ \'fcmMessageId\', \'fcmToken\' ] })
 */
export interface PersonalRequisitionExcludingFcmMessageIdFcmTokenWithRelations { 
    deleted?: boolean;
    deletedOn?: string | null;
    deletedBy?: string | null;
    createdOn?: string;
    modifiedOn?: string;
    createdBy?: number;
    modifiedBy?: number;
    id?: string;
    employeeReplaceName?: string;
    employeeReplaceId?: number;
    salary?: number | null;
    city: string;
    creationReason?: string;
    code?: string;
    followsAuthorizationFlow?: boolean;
    requisitionTypeId?: string;
    jobPositionId?: string;
    currentStatusId?: string;
    immediateSuperiorId?: number;
    areaManagerId?: number;
    generalManagerId?: number;
    financeDirectorId?: number;
    createdByUser?: object;
    humanCapitalCompanyId?: string;
    companyId?: string;
    businessUnitId?: string;
    employeeReplace?: UserExcludingFcmMessageIdFcmTokenWithRelations;
    requisitionType?: PersonalRequisitionTypeExcludingFcmMessageIdFcmTokenWithRelations;
    jobPosition?: JobPositionExcludingFcmMessageIdFcmTokenWithRelations;
    currentStatus?: RequisitionStatusExcludingFcmMessageIdFcmTokenWithRelations;
    immediateSuperior?: UserExcludingFcmMessageIdFcmTokenWithRelations;
    areaManager?: UserExcludingFcmMessageIdFcmTokenWithRelations;
    generalManager?: UserExcludingFcmMessageIdFcmTokenWithRelations;
    financeDirector?: UserExcludingFcmMessageIdFcmTokenWithRelations;
    requisitionComments?: Array<RequisitionCommentExcludingFcmMessageIdFcmTokenWithRelations>;
    requisitionStatusHistories?: Array<RequisitionStatusHistoryExcludingFcmMessageIdFcmTokenWithRelations>;
    humanCapitalCompany?: HumanCapitalCompanyExcludingFcmMessageIdFcmTokenWithRelations;
    company?: CompanyExcludingFcmMessageIdFcmTokenWithRelations;
    businessUnit?: BusinessUnitExcludingFcmMessageIdFcmTokenWithRelations;
}

